import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Box, Breadcrumbs, Button, Typography } from '@mui/material';
import { useState } from 'react';
import { useNotify, useRedirect } from 'react-admin';
import {
  ConditionWithRelationsForm,
  CreateConditionPayload,
} from '../../../../interfaces/health-data';
import healthDataService from '../../../../services/health-data';
import { ConditionForm } from './ConditionForm/ConditionForm';
import './css/conditions.css';

export const CreateCondition = () => {
  const [form, setForm] = useState<CreateConditionPayload | null>(null);

  const breadcrumbLabels = ['conditions', 'create'];

  const notify = useNotify();
  const redirect = useRedirect();

  const handleSubmit = async () => {
    if (!form) {
      return;
    }

    const response = await healthDataService.createCondition(form);

    if (!response.data) {
      notify(response.message || 'There was an error saving condition', 'warning');
      return;
    }

    notify('Condition created successfully');
    redirect(`/medical-setup/conditions/${response.data.condition.id}/show`);
  };

  const handleUpdateForm = (form: ConditionWithRelationsForm) => {
    const { condition, laboratoryTests, procedures, medications } = form;

    const laboratoryTestParams = laboratoryTests.map((lb) => ({
      id: lb.laboratoryTest.id,
      validityPeriodFrom: lb.validityPeriodFrom,
      validityPeriodUntil: lb.validityPeriodUntil,
    }));

    const proceduresParams = procedures.map((p) => ({
      id: p.procedure.id,
      validityPeriodFrom: p.validityPeriodFrom,
      validityPeriodUntil: p.validityPeriodUntil,
    }));

    const medicationsParams = medications.map((md) => ({
      id: md.medication.id,
    }));

    setForm({
      ...condition,
      description: condition.description || '',
      laboratoryTests: laboratoryTestParams,
      procedures: proceduresParams,
      medications: medicationsParams,
    });
  };

  return (
    <Box>
      <Box display='flex' justifyContent='space-between' className='tab-section-action-bar'>
        <Breadcrumbs separator={<NavigateNextIcon fontSize='small' />}>
          {breadcrumbLabels.map((text, index) => {
            return (
              <Typography key={`text-condition-breadcrumb-${index}`} textTransform='capitalize'>
                {text}
              </Typography>
            );
          })}
        </Breadcrumbs>

        <Button
          onClick={handleSubmit}
          disabled={!form}
          variant='contained'
          sx={{ textTransform: 'capitalize' }}>
          Save
        </Button>
      </Box>

      <ConditionForm onChangeForm={(v) => handleUpdateForm(v)} />
    </Box>
  );
};
